import { AuthService } from './../../shared/models/auth.service';
import { TranslateService } from './../../shared/translate/translate.service';
import { ContractTypeGroupService } from './../../contracttypegroup/models/contracttypegroup.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { SubscriptionModel } from '../models/sharedvehiclegroupsubscription.model';
import { SubscriptionService } from '../models/sharedvehiclegroupsubscription.service';
import { Observable } from 'rxjs/Observable';
import { Router, ActivatedRoute } from '@angular/router';
import { WeGoConfig, IAPIResponse, ApplicationRouteURL, DataListModel, Permission, WeGoAuthorizedLink, PermissionType, Entity, RoleLevel } from '../../shared/config';
import { SharedVehicleGroupService } from './../../sharedvehiclegroup/models/sharedvehiclegroup.service';

@Component({
  selector: 'wego-subscription-list',
  template: require('../views/sharedvehiclegroupsubscription-list.component.html'),
  providers: [SubscriptionService, ContractTypeGroupService, SharedVehicleGroupService],
})

export class SubscriptionListComponent implements OnInit {
  DataListModel: DataListModel;
  subscriptionList: SubscriptionModel[];
  apiErrorMsg: string;
  isLoading: boolean;
  urlSubscriptionUpdate: string;
  urlSubscriptionAdd: string;
  urlDefaultPage: string;
  urlSVGList: string;
  sharedVehicleGroupHashId: string = "";
  private breadCrumbList: string;
  private module: string;
  private sharedvehicleGroup: string;
  apiResponse: IAPIResponse;
  contractTypeGroupList: any;
  alertMsg: string;
  isMultipleDelete: boolean;
  deleteSubscriptionHashId: string;
  private popupMsg: string;
  private popupTitle: string;
  private groupName: string;
  urlSubscriptionAvailability: string;
  private addSVGSubscriptionLink : any;
  roleLevel = RoleLevel;


  @ViewChild('alertModal') public alertModal: any;
  @ViewChild('confirmModal') public confirmModal: any;
  @ViewChild('successPopup') public successPopup: any;

  constructor(private subscriptionService: SubscriptionService,
    private translate: TranslateService,
    private contractTypeGroupService: ContractTypeGroupService,
    private authService: AuthService,
    private activeRoute: ActivatedRoute,
    private sharedvehiclegroupService: SharedVehicleGroupService,
    private router: Router) {
  }

  ngOnInit() {
    this.module = this.translate.instant('LblSubscription', [this.module]);
    this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
    this.sharedvehicleGroup = this.translate.instant('LblListPage', this.translate.instant('LblSharedVehicleGroup'));

    this.module = this.translate.instant('LblSubscription', [this.module]);
    this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
    this.sharedvehicleGroup = this.translate.instant('LblListPage', this.translate.instant('LblSharedVehicleGroup'));

    this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
    this.DataListModel.searchField = ["name", "timeInterval", "description"];
    this.urlDefaultPage = this.authService.GetURL(ApplicationRouteURL.URL_DEFAULT_PAGE);
    this.urlSVGList = this.authService.GetURL(ApplicationRouteURL.URL_SVG_LIST);
    this.urlSubscriptionUpdate = this.authService.GetURL(ApplicationRouteURL.URL_SUBSCRIPTION_UPDATE);
    this.urlSubscriptionAdd = this.authService.GetURL(ApplicationRouteURL.URL_SUBSCRIPTION_ADD);
    this.urlSubscriptionAvailability = this.authService.GetURL(ApplicationRouteURL.URL_SUBSCRIPTIONAVAILABILITY_LIST);
    //this.GetSubscriptionList();

    this.activeRoute
      .params
      .subscribe(params => {
        let sharedVehicleGroupHashId = params['id'] || '';
        if (sharedVehicleGroupHashId != '') {
          this.sharedVehicleGroupHashId = sharedVehicleGroupHashId;
          this.GetSharedVehicleGroupDetailsByHashId();
          this.GetSubscriptionList();
          this.addSVGSubscriptionLink = new WeGoAuthorizedLink("",
          Permission.PR_SHARED_VEHICLE_GROUP_SUBSCRIPTION_OVERVIEW, PermissionType.INSERT, 'btn btn-highlight navbar-right', 'LblAddNew', Entity.SVG, this.sharedVehicleGroupHashId);
        }
      });
  }

  public AddNewSubscription(sharedVehicleGroupHashId: string) {
    console.log(sharedVehicleGroupHashId);
    this.sharedVehicleGroupHashId = sharedVehicleGroupHashId;
    this.GetContractTypeGroupList();
  }

  public GetContractTypeGroupList() {
    this.contractTypeGroupService.GetContractTypeGroupBySharedVehicleGroup(this.sharedVehicleGroupHashId, this.DataListModel)
      .subscribe(
      res => {
        this.apiResponse = res;
        this.contractTypeGroupList = res.data;
        if (res.data.length > 0) {
          this.router.navigate([this.urlSubscriptionAdd, { 'sharedVehicleGroupHashId': this.sharedVehicleGroupHashId }]);
        }
        else {
          this.ShowAlertModal();
        }
        console.log('contractTypeGroupList');
        console.log(this.contractTypeGroupList);
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      }
      );
  }

  public GetSubscriptionList() {
    this.isLoading = true;
    this.subscriptionService.GetSubscriptionList(this.sharedVehicleGroupHashId, this.DataListModel)
      .subscribe(
      res => {
        this.subscriptionList = res.data;
        this.DataListModel.totalItems = res.totalRecords;
        this.DataListModel.infoMessage = res.error;
        this.isLoading = false;
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  public OnPagingChange(event: any) {
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetSubscriptionList();
  }

  public OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetSubscriptionList();
  }

  public OnSearch(event: any) {
    this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
    this.GetSubscriptionList();
  }

  public OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetSubscriptionList();
  };

  public OnExport(event: any) {
    this.isLoading = true;
    this.subscriptionService.ExportSubscriptionList(this.sharedVehicleGroupHashId, this.DataListModel)
      .subscribe(
      (res: any) => {
        if (res && res._body) {
          let fileName = "Subscription" + new Date().toISOString() + ".csv";
          this.authService.DownloadFile(fileName, res._body);
        }
        this.isLoading = false;
      },
      (error: any) => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });;
  }
  public GetSharedVehicleGroupDetailsByHashId() {
    this.sharedvehiclegroupService.GetSharedVehicleGroupBasicDetail(this.sharedVehicleGroupHashId)
      .subscribe(
      res => {
        if (res.data)
          this.groupName = res.data.entityName;
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }


  public ShowAlertModal(): void {
    this.isLoading = false;
    this.alertMsg = this.translate.instant('LblContractTypeGroupAvailableForSubscription', [this.module]);
    this.popupTitle = this.translate.instant('LblWarning');
    this.alertModal.show();

  }
  public HideAlertModal(): void {
    this.alertModal.hide();
  }

  public OnParentCheck(isChecked: boolean) {
    this.subscriptionList.forEach(x => x.isChecked = isChecked);
  }


  public ConfirmSuccessClick(): void {
    this.confirmModal.hide();
    this.DeleteSubsription();
  }

  public ShowConfirmModal(subscriptionHashId: string): void {
    this.isLoading = false;
    this.popupMsg = this.translate.instant('LblRecordDeleteConfirmation', [this.module]);
    this.confirmModal.show();
    this.deleteSubscriptionHashId = subscriptionHashId;

  }

  public HideConfirmModal(): void {
    this.confirmModal.hide();
  }

  public DeleteSubsription() {
    this.isLoading = true;
    this.subscriptionService.DeleteSubsription(this.deleteSubscriptionHashId)
      .subscribe(
      (res: any) => {
        if (res.data) {
          this.DataListModel.currentPage = 1;
          this.GetSubscriptionList();
          this.popupTitle = this.translate.instant('LblSuccess');
          this.popupMsg = this.translate.instant('LblRecordRemovedSuccess', [this.module]);
          this.ShowSuccessPopup();
        }
        if (res.error) {
          this.popupTitle = this.translate.instant('LblWarning');
          this.popupMsg = res.error;
          this.isLoading = false;
          this.ShowSuccessPopup();
        }
      },
      (error: any) => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }

  public HideSuccessPopup(): void {
    this.successPopup.hide();
  }

  public ConfirmSuccessPopup(): void {
    this.successPopup.hide();
  }
  ngOnDestroy() {
    this.authService.SetFilter(this.constructor.name, this.DataListModel);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/sharedvehiclegroupsubscription/components/sharedvehiclesubscription-list.component.ts